import React from "react";

const QuickReviewIcon = ({ active }) => (
  <div className="quickreview-icon-container">
    <div className={`outer-background ${active ? "dark-background" : ""}`}>
      <div className="outer-circle">
        <div className={`mid-background ${active ? "dark-background" : ""}`}>
          <div className="mid-circle rotating" />
          <div
            className={`inner-background ${active ? "dark-background" : ""}`}>
            <div
              id="revv-bar"
              className={`bar ${active ? "translate-hor" : ""}`}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default QuickReviewIcon;



// WEBPACK FOOTER //
// ./src/components/QuickReview/QuickReviewIcon.js